export const buildAdministrative = (navigation, strings, permissions = [], onClick, flags = []) => {
  const hasTerm = !!navigation?.term?.id;
  const hasYear = !!navigation?.year?.id;
  const hasArea = !!navigation?.area?.id;
  if (!hasArea) {
    return null;
  }


  const areaUrl = `/areas/${navigation.area.id}`;
  let directoryBaseUrl = areaUrl;

  const programId = navigation?.program?.id;
  const coordinatorId = navigation?.coordinator?.id;
  const regionId = navigation?.region?.id;
  const areaId = navigation?.area?.id;

  const isSucceedInSchool = navigation?.program?.programType === "sis";

  let curLevelId = programId;
  if (isNaN(curLevelId)) {
    curLevelId = coordinatorId;
  }
  if (isNaN(curLevelId)) {
    curLevelId = regionId;
  }
  if (isNaN(curLevelId)) {
    curLevelId = areaId;
  }

  let canViewReports = permissions.find(p => p.permission === "CanViewProgramReports" &&
    p.targetId.toString() === curLevelId.toString());

  const canAdminProgram = !!permissions.find(
    (p) =>
      p.permission === "CanEditProgramSupplemental" &&
      p.targetId.toString() === curLevelId.toString()
  );
  if (!canAdminProgram && !canViewReports) {
    return null;
  }

  let baseUrl = navigation.region
    ? `${areaUrl}/regions/${navigation.region.id}`
    : `/areas/${navigation.area.id}/regions/na`;
  let queryString = "";
  if (navigation.region) {
    directoryBaseUrl = baseUrl;
  }


  baseUrl = navigation.coordinator
    ? `${baseUrl}/coordinators/${navigation.coordinator.id}`//  /programs/${navigation.program.id}`
    : `${baseUrl}/coordinators/na`; //programs/${navigation.program.id}`;
  if (navigation.coordinator) {
    directoryBaseUrl = baseUrl;
  }

  const item = {
    type: "group",
    label: strings.AdministrativeTools,
    "data-id": "accordion-administrative-tools-group",
    items: [],
  };

  if (navigation.program) {
    baseUrl = `${baseUrl}/programs/${navigation.program.id}`;
    directoryBaseUrl = baseUrl;
  }



  if (hasYear && hasTerm) {
    baseUrl = `${baseUrl}/years/${navigation.year.id}/terms/${navigation.term.id}`;
    queryString = `?yearId=${navigation.year.id}&termId=${navigation.term.id}`;
  }

  //this child item doesn't show to one who just can view reports
  if (hasYear && hasTerm && canAdminProgram) {
    item.items.push({
      id:1,
      type: "link",
      "data-id": "accordian-administrative-close-term",
      label: strings.CloseTerm,
      href: `${baseUrl}/closeTerm`,
      onClick:(e) => {
        onClick({
          event:e,
          href: `${baseUrl}/closeTerm`,
        });
      }
    });

    item.items.push({
      id:2,
      type: "link",
      "data-id": "accordian-administrative-merge-students",
      label: strings.mergeStudents,
      href: `${baseUrl}/merge-students`,
      onClick: (e) => {
        onClick({
          event: e,
          href: `${baseUrl}/merge-students`,
        });
      }
    });
  }

  //employee directory  news and events and graduation not visible to those who can only view reports
  if (canAdminProgram) {
    item.items.push({
      id:3,
      type: "link",
      "data-id": "accordian-administrative-employee-directory",
      label: strings.employeeDirectory,
      href: `${directoryBaseUrl}/employee-directory`,
      onClick: (e) => {
        onClick({
          event: e,
          href: `${directoryBaseUrl}/employee-directory${queryString}`,
        });
      }
    });

    if (hasYear && hasTerm && !isSucceedInSchool) {
      item.items.push({
        id:5,
        type:"link",
        label: strings.graduation,
        "data-id": "accordian-stake-graduation",
        href: `${baseUrl}/graduation/stakes`,
        onClick:(e) => {
          onClick({
            event:e,
            href: `${baseUrl}/graduation/stakes`,
          });
        }
      })
    };
  }

  //reports available to anyone who can admin or view reports so long as we have a year and term
  if ((canAdminProgram || canViewReports) && hasYear && hasTerm) {
    item.items.push({
      id:6,
      type:"link",
      label:strings.reports,
      "data-id":"accordian-reports",
      href: `${baseUrl}/reports`,
      onClick:(e) => {
        onClick({
          event:e,
          href: `${baseUrl}/reports`,
        });
      }
    })
  }

  const canAdminApplication = permissions?.find(p => p && p.permission === "CanAdminApplication" &&
   p.targetId?.toString() === "7");

  if (canAdminApplication) {
    item.items.push({
      id:7,
      type:"link",
      label:strings.courseManagement,
      "data-id":"accordian-course-management",
      href: "/admin/course-management",
      onClick:(e) => {
        onClick({
          event:e,
          href: "/admin/course-management",
        });
      }
    })
  }


  return item;
};
